import type { ConversationSummary, Profile } from '../types';

export function getConversationTitle(conversation: ConversationSummary, currentUserId: string) {
  if (conversation.type === 'group') return conversation.name || 'Untitled group';

  const otherMember = conversation.members.find((member) => member.user_id !== currentUserId);
  return otherMember?.profile.display_name || otherMember?.profile.username || 'Direct message';
}

export function getConversationAvatar(conversation: ConversationSummary, currentUserId: string) {
  if (conversation.avatar_url) return conversation.avatar_url;
  const otherMember = conversation.members.find((member) => member.user_id !== currentUserId);
  return otherMember?.profile.avatar_url || null;
}

export function getOtherMember(conversation: ConversationSummary, currentUserId: string) {
  return conversation.members.find((member) => member.user_id !== currentUserId)?.profile || null;
}

export function profileMatches(profile: Profile, query: string) {
  const normalized = query.toLowerCase();
  return (
    profile.username.toLowerCase().includes(normalized) ||
    profile.display_name.toLowerCase().includes(normalized)
  );
}

